export enum TariffType {
  Hourly = 'hourly',
  Daily = 'daily'
}

type DetailedTariff = { price: number; validFrom: number }

export type ParkingTariff = {
  tariffType: TariffType
  tariffs: DetailedTariff[]
}

export type QuickInterval = {
  name: string
  isDefault: boolean
  type: TariffType
  startDateTime: string
  endDateTime: string
}

export type BookedSlot = {
  start: string
  end: string
  isMine: boolean
}

export type ParkingSummary = {
  totalSum: number
  tariff: number
  durationSeconds: number
  freeSeconds: number
  offerUrl: string
}

export type CreateBookingResponse = {
  bookingId: string
  invoiceId: string
}

export type CreateBookingFormData = Omit<CreateBookingDTO, 'projectId'>

export type CreateBookingDTO = {
  premiseId: string
  from: string
  to: string
  autoModel: string
  autoNumber: string
  projectId: string
  type: TariffType
  isStandard: boolean
  personalAccountId?: string
}

export type Auto = {
  id: string
  emoji: string
  number: string
  region: string
  model: string | null
  description: string
  isStandard: boolean
  order: number
}

export type AutoDTO = {
  emoji: string
  number: string
  model: string | null
  description: string
  isStandard: boolean
}

export type CreateAutoResponse = Omit<Auto, 'emoji' | 'region'>

export type ReorderAutosDTO = {
  autosId: string[]
}
